function calculateThumbnailsVisibility() {
    if (window.innerWidth < 1024) {
        const viewMoreButton = document.getElementById('view-more-button');
        viewMoreButton.style.display = 'none';
        return
    }

    const container = document.querySelector('.labyrinth-brands__thumbnails');
    const thumbnailsList = document.getElementById('labyrinth-thumbnails');
    if (!container || !thumbnailsList) return;

    const viewMoreBtn = container.querySelector('.labyrinth-brands__view-more');
    const btnHeight = viewMoreBtn ? viewMoreBtn.offsetHeight : 0;

    const gapStr = getComputedStyle(thumbnailsList).getPropertyValue('gap').trim();
    const gapValue = parseFloat(gapStr);

    let availableHeight = container.offsetHeight - btnHeight;
    if (availableHeight > window.innerHeight) {
        availableHeight = window.innerHeight - btnHeight - 73.375;
    }

    // Filter only thumbnail card nodes
    const thumbnailNodes = Array.from(thumbnailsList.children).filter(node =>
        node.classList.contains('labyrinth-brands__thumbnail-wrapper')
    );

    // Measure the first card only (assume all same height)
    let cardHeight = 0;
    if (thumbnailNodes.length > 0) {
        // Make sure one is visible for correct measurement
        thumbnailNodes[0].style.display = '';
        cardHeight = thumbnailNodes[0].offsetHeight + gapValue;
    }

    // How many fit?
    const maxVisible = cardHeight > 0 ? Math.floor(availableHeight / cardHeight) : thumbnailNodes.length;

    // Only show those that fit
    thumbnailNodes.forEach((node, i) => {
        node.style.display = i < maxVisible ? '' : 'none';
    });

    // Show "View More" if some were hidden
    const overflow = maxVisible < thumbnailNodes.length;
    if (viewMoreBtn) viewMoreBtn.style.display = overflow ? 'block' : 'none';
}

// Debounced event handlers
function debounce(func, delay) {
    let timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(func, delay);
    }
}

window.addEventListener('resize', debounce(calculateThumbnailsVisibility, 200));
window.addEventListener('load', calculateThumbnailsVisibility);
